import moment from "moment";

import { deriveFinishDate } from "utils/medicationDates";

/**
 * A row from the Long term / Acute medication lists, as a medicine in the prescription form.
 *
 * The lists send `GroupedPatientMedicationDTO`, which names the catalog link `medicationId` and the
 * pack `pack`. Reading `medicineId` and `packSize` instead ticked Manual Entry on every renewed item
 * and left Pack Size blank. The note arrives as null when there is none, which the form schema
 * refused, so from Oct 20 Save did nothing on any renewal.
 */
export const toRenewedMedicine = (medication) => {
  const startDate = moment().format("DD-MM-YYYY");

  return {
    ...medication,
    // Only manual when the original had no drug-catalog link; otherwise keep the catalog
    // link so submit sends medicationId instead of silently falling back to free-text fields.
    isManual: !medication.medicationId,
    medicineId: medication.medicationId || "",
    tradeName: medication.tradeName || "Unknown Medication",
    manufacturer: medication.manufacturer || "",
    packSize: medication.pack != null ? medication.pack.toString() : "",
    dosage: medication.dosage || "As prescribed",
    form: medication.form || "Tablet",
    startDate,
    finishDate: deriveFinishDate({
      startDate,
      duration: medication.duration,
      durationFormat: medication.durationFormat || "days",
    }),
    duration: medication.duration ? medication.duration.toString() : "",
    durationFormat: medication.durationFormat || "days",
    usageType: medication.usageType || "LONGTERM",
    repeat: medication.repeat ? medication.repeat.toString() : "",
    route: medication.route || "",
    frequency: medication.frequency || "",
    quantity: medication.quantity ? medication.quantity.toString() : "",
    note: medication.note ?? "",
  };
};
